import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgetPasswordRoutingModule } from './forget-password-routing.module';
import { ForgetPasswordComponent } from './pages/forget-password/forget-password.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    ForgetPasswordRoutingModule,
    CoreModule,
  ],
  declarations: [
    ForgetPasswordComponent,
  ]
})
export class ForgetPasswordModule { }
